import { DeviceStatus } from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const dacTranslations = {
  YOU_HAVENT_ENABLED_DAC: `You haven't enabled Access Control in`,
  PREFERENCES: 'Preferences',
  THIS_IS_WHERE_YOU: 'This is where you approve and manage your devices',
  MAKE_SURE_YOU: `Make sure you enable 'Access Control' in`,
  TO_START_APPROVING: 'to start approving devices',
  [DeviceStatus.approved]: 'Approved',
  [DeviceStatus.blocked]: 'Blocked',
  [DeviceStatus.pending]: 'Pending',
  DEVICE_NAME: 'Device name',
  DEVICE_MODEL: 'Device model',
  LAST_SEEN: 'Last seen',
  LAST_USED_BY: 'Last used by',
  DEVICES: 'Devices',
  VIEW_ALL: 'View all device sign-ins',
  PSST: 'Pssst... This page is undercover',
  NO_PERMISSIONS:
    'You do not have permission view this page, speak to your manager if you think this is a mistake.',
  NO_DEVICES_APPROVED: 'No devices have been approved ',
  DEVICES_APPROVE: `Devices you've approve will show here. You can enable or disable Access Control in`,
  NO_DEVICES_BLOCKED: 'No devices have been blocked',
  DEVICES_BLOCKED: `Devices you've blocked will show here. You can enable or disable Access Control in`,
  MANAGE: 'Manage',
  DEVICES_PENDING: 'No pending devices',
  VIEW_DEVICE: 'View Device Sign-ins',
  MANAGE_DEVICE: 'Manage device',
  MODEL_NAME: 'Model name',
  APPROVE_SELECTED: 'Approve selected',
  SITES_SELECTED: 'sites selected',
  SITE_NAME: 'Site name',
  STATUS: 'Status',
  ACTION: 'Action',
  APPROVE: 'Approve',
  BLOCK: 'Block',
  SELECT_ITEMS: 'Select items using the checkboxes',
  ARE_YOU_SURE_YOU_WANT: 'Are you sure you want to do this?',
  ARE_YOU_SURE_YOU_WANT_BLOCK_THIS_SITE:
    'Do you want proceed with blocking access to this site?',
  ARE_YOU_SURE_YOU_WANT_APPROVE_THIS_SITE:
    'Do you want proceed with granting access to this site?',
  ARE_YOU_SURE_YOU_WANT_APPROVE_THIS_SITE_ALL:
    'Do you want proceed with granting access all sites?',
  NO_REQUEST: 'NO REQUEST',
  DEVICE_NAME_TAKEN: 'The device name has already been taken',
  DEVICE_SIGN_INS: 'Device sign-ins',
  FROM: 'From',
  TO: 'To',
  SIGN_IN: 'Sign-in',
  CARER: 'Carer',
  LOCATION: 'Location',
  CANT_FIND_ANY: `Can't find any sign-ins to show you`,
  WHEN_A_DEVICE:
    'When a device signs-in it will show here. Make sure you have enabled Access Control in',
  PLEASE_SELECT: 'Please select',
  OPEN_IN_MAPS: 'Open in Maps',
  GPS_TURNED_OFF: 'GPS turned off',
  NEEDS_PERMISSION: 'Needs permission',
  BLOCK_DEVICE: 'Block the device',
  BLOCK_DEVICE_ALL: 'This action will block access',
  BLOCK_DEVICE_ALL_DESC: 'The mobile device will be restricted for this site',
  APPROVE_DEVICE: 'Approve the device',
  APPROVE_DEVICE_ALL: 'This action will approve the device',
  APPROVE_DEVICE_ALL_SELECTED: 'Approve device for all selected?',
  APPROVE_DEVICE_ALL_SELECTED_DESC:
    'The mobile device will now be granted access for all sites selected.',
  APPROVE_DEVICE_ALL_DESC: 'The mobile device will be approved for this site.',
  BLOCK_DEVICE_GROUP_DESC:
    'The mobile device will be restricted for this site. If you wish to block access to multiple sites, please click `Manage` from the dropdown menu.',
  APPROVE_DEVICE_GROUP_DESC: `Access will now be granted for this site. If you need to approve access for multiple sites, simply click 'Manage' from the dropdown menu.`,
  BLOCK_DEVICE_NOT_GROUP_DESC: `The device will be blocked for this site. See more details by clicking 'Manage' from the dropdown.`,
  APPROVE_DEVICE_NOT_GROUP_DESC: `The device will be approved for this site. See more details by clicking 'Manage' from the dropdown.`,
  APP_VERSION: 'App version',
  TEAM_MEMBER: 'Team Member',
  HOW_DO_I_SETUP: 'How do I set up Device Access Control?',
  HOW_DO_I_APPROVE: 'How do I approve a new device for my care home?',
  HOW_DO_I_MANAGE: 'How do I manage devices in my care home?',
  CURRENT_SITE: '(Current site)',
}

export const dacConstants = getKeys(dacTranslations)
